import React, { Component } from 'react';

import ring from '../components/LoadingSvg/DoubleRing.svg';
class Loading extends Component {
    render() {
        return (
            <div className="m-5" style={{ textAlign: 'center' }}>
                <p style={{ marginBottom: "-30px" }}>در حال بارگذاری ...</p>
                <img src={ring} width="140" alt="" />
            </div>

        );
    }
}
export default Loading;

